import awsmobile from 'config/aws'
import Amplify from 'aws-amplify'

export const configureAmplify = () => {
  Amplify.configure(awsmobile)
}
